import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableRow from "@material-ui/core/TableRow";
// import Typography from "@material-ui/core/Typography";
import { DialogProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

import { maybe } from "../../../misc";

export interface OrderProductDetailsDialogProps extends DialogProps {
  orderId: string;
  variant: any;
}

const useStyles = makeStyles(
  theme => ({
    buttonActionFlex: {
      flexDirection: "column"
    },
    buttonActions: {
      display: "flex",
      width: "100%"
    },
    buttonBack: {
      background: "#f9f9f9  !important",
      border: "1px solid #E5E5E5 !important",
      margin: "3px",
      width: "100%"
    },
    buttonBackLabel: {
      color: "#3D3D3D"
    },
    buttonLabelBlack: {
      color: "#3D3D3D"
    },
    buttonLabelWhite: {
      color: "white !important"
    },
    buttonOutOfStock: {
      color: "#E26139 !important"
    },
    buttonPicked: {
      alignContent: "center",
      background: "#0030FF !important",
      marginLeft: "0px !important",
      width: "100%"
    },
    buttonPicking: {
      background: "#FFFFFF !important",
      border: "1px solid #A9A6A6  !important",
      margin: "5px",
      width: "100%"
    },
    containedGray: {
      backgroundColor: "#A1A1A1 !important",
      margin: "5px",
      marginLeft: "0px",
      width: "100%"
    },
    outlineOrange: {
      border: "1px solid #E26139 !important",
      margin: "5px",
      marginRight: "0px",
      width: "100%"
    },
    root: {
      ...theme.typography.body1,
      lineHeight: 1.9,
      width: "100%"
    },
    textBold: {
      fontSize: "20px",
      fontWeight: 600,
      paddingLeft: "1em",
      textAlign: "left",

      width: "30%",
      [theme.breakpoints.down("md")]: {
        fontSize: "16px",
        paddingLeft: "0em",
        textAlign: "left"
      }
    },
    textRight: {
      fontSize: "20px",
      paddingLeft: "1em",
      textAlign: "left",
      [theme.breakpoints.down("md")]: {
        fontSize: "15px",
        paddingLeft: "0em"
      }
    }
  }),
  { name: "OrderProductDetailsDialog" }
);

const OrderProductDetailsDialog: React.FC<OrderProductDetailsDialogProps> = props => {
  const { onClose, open, orderId: variantId, variant } = props;
  const classes = useStyles(props);

  const [product, setProduct] = React.useState({
    notes: "",
    productName: "",
    quantity: "",
    status: "",
    totalPrice: { gross: { amount: "" } },
    unitPrice: { gross: { amount: "" } },
    variant: {
      sku: ""
    },
    variantName: ""
  });

  const checkStatusLabel = () => {
    switch (product.status) {
      case "OUT_OF_STOCK":
        return <span>Out Of Stock</span>;
      case "PICKING":
        return <span>Picking</span>;
      case "PICKED":
        return <span>Picked</span>;
      default:
        return <span></span>;
    }
  };

  const formatter = new Intl.NumberFormat("en-PH", {
    currency: "PHP",
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    style: "currency"
  });

  const formatCurrency = (price: string) => {
    const parsedPrice = parseFloat(price);
    return formatter.format(parsedPrice);
  };

  React.useEffect(() => {
    if (variant && variant.lines.length > 0) {
      setProduct(
        maybe(() => variant.lines.find(({ id }) => id === variantId), [])
      );
    }
  }, [variant && variant.lines && variantId]);

  return (
    <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
      <>
        <DialogTitle>{product.productName}</DialogTitle>
        <DialogContent>
          <table className={classes.root}>
            <tbody>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Variant"
                    description="order detail variant"
                  />
                </th>
                <td className={classes.textRight}>{product.variantName}</td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="SKU Code"
                    description="order detail variant"
                  />
                </th>
                <td className={classes.textRight}>{product?.variant?.sku}</td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Quantity"
                    description="order detail qantity"
                  />
                </th>
                <td className={classes.textRight}>{product.quantity + "x"} </td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Price"
                    description="order detail price"
                  />
                </th>
                <td className={classes.textRight}>
                  {formatCurrency(product.unitPrice.gross.amount)}
                </td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Total"
                    description="order detail total"
                  />
                </th>
                <td className={classes.textRight}>
                  {formatCurrency(product.totalPrice.gross.amount)}
                </td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Status"
                    description="order detail status"
                  />
                </th>
                <td className={classes.textRight}>{checkStatusLabel()}</td>
              </tr>
              <tr>
                <th className={classes.textBold}>
                  {" "}
                  <FormattedMessage
                    defaultMessage="Note"
                    description="order detail note"
                  />
                </th>
                <td className={classes.textRight}>{product.notes}</td>
              </tr>
            </tbody>
          </table>
        </DialogContent>
        <DialogActions className={classes.buttonActionFlex}>
          <Button
            id="backBtn"
            onClick={onClose}
            variant="contained"
            color="default"
            className={classes.buttonBack}
          >
            <span className={classes.buttonBackLabel}>BACK</span>
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
};
OrderProductDetailsDialog.displayName = "OrderProductDetailsDialog";
export default OrderProductDetailsDialog;
